<template>
	<div>
		<div v-if="pagine.length" class="mb-3">
			<div class="d-flex align-center mb-1">
				<v-icon small color="warning" class="mr-1">mdi-alert-circle-outline</v-icon>
				<strong>Pagine da verificare ({{ pagine.length }})</strong>
				<v-spacer></v-spacer>
				<v-btn x-small text color="primary" :disabled="occupato" @click="esegui('retry', pagine.slice(0, 50).map(p => p.url))">Riprova tutte</v-btn>
			</div>
			<div class="caption grey--text mb-1">
				Le regole non leggono i dati di queste pagine. Se non sono prodotti (link sbagliati) escludile: la scansione non le visiterà più. Se sono prodotti, sistema la taratura e riprova.
			</div>
			<v-simple-table dense class="tabella">
				<tbody>
					<tr v-for="p in visibili" :key="p.url">
						<td class="indirizzo">{{ percorso(p.url) }}</td>
						<td class="text-no-wrap">
							<v-chip v-for="m in p.missing || []" :key="m" x-small outlined color="warning" class="mr-1">manca {{ etichetta(m) }}</v-chip>
						</td>
						<td class="text-right" style="width: 40px">
							<v-menu offset-y left>
								<template #activator="{ on, attrs }">
									<v-btn icon small :disabled="occupato" v-bind="attrs" v-on="on"><v-icon small>mdi-dots-vertical</v-icon></v-btn>
								</template>
								<v-list dense>
									<v-list-item :href="p.url" target="_blank" rel="noopener noreferrer">
										<v-list-item-icon class="mr-2"><v-icon small>mdi-open-in-new</v-icon></v-list-item-icon>
										<v-list-item-title>Apri la pagina</v-list-item-title>
									</v-list-item>
									<v-list-item @click="esegui('exclude', [p.url])">
										<v-list-item-icon class="mr-2"><v-icon small>mdi-cancel</v-icon></v-list-item-icon>
										<v-list-item-title>Escludi (link sbagliato)</v-list-item-title>
									</v-list-item>
									<v-list-item @click="esegui('retry', [p.url])">
										<v-list-item-icon class="mr-2"><v-icon small>mdi-refresh</v-icon></v-list-item-icon>
										<v-list-item-title>Riprova</v-list-item-title>
									</v-list-item>
									<v-list-item @click="esegui('dismiss', [p.url])">
										<v-list-item-icon class="mr-2"><v-icon small>mdi-eye-off-outline</v-icon></v-list-item-icon>
										<v-list-item-title>Ignora</v-list-item-title>
									</v-list-item>
								</v-list>
							</v-menu>
						</td>
					</tr>
				</tbody>
			</v-simple-table>
			<v-btn v-if="pagine.length > visibili.length" x-small text class="mt-1" @click="tutte = true">Mostra tutte ({{ pagine.length }})</v-btn>
		</div>

		<div v-if="esclusi.length" class="caption">
			<a href="#" @click.prevent="mostraEsclusi = !mostraEsclusi">{{ esclusi.length }} {{ esclusi.length === 1 ? 'pagina esclusa' : 'pagine escluse' }}</a>
			<div v-if="mostraEsclusi" class="mt-1">
				<div v-for="u in esclusi" :key="u" class="d-flex align-center">
					<span class="indirizzo grey--text">{{ percorso(u) }}</span>
					<v-spacer></v-spacer>
					<v-btn x-small text color="primary" :disabled="occupato" @click="esegui('include', [u])">Includi di nuovo</v-btn>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { CAMPI, testoErrore } from './testi';

const VISIBILI = 10;
const MESSAGGI = {
	exclude: 'Pagina esclusa: la scansione non la visiterà più.',
	dismiss: 'Pagina tolta dall\'elenco.',
	include: 'Pagina inclusa di nuovo nella scansione.',
	retry: 'Riscansione avviata.',
};

// Pagine che la scansione non riesce a leggere (config.pagesToCheck, scritto dal worker) e pagine
// escluse dal merchant (config.excludedUrls). Segnala `changed` (con il job se e' partita una
// riscansione) e `message` a chi lo ospita.
export default {
	name: 'BrandImportPagineDaVerificare',
	props: {
		brandId: { type: String, required: true },
		config: { type: Object, default: () => ({}) },
	},
	data() {
		return { occupato: false, tutte: false, mostraEsclusi: false };
	},
	computed: {
		pagine() {
			return [...(this.config.pagesToCheck || [])].reverse();
		},
		visibili() {
			return this.tutte ? this.pagine : this.pagine.slice(0, VISIBILI);
		},
		esclusi() {
			return this.config.excludedUrls || [];
		},
	},
	methods: {
		etichetta(campo) {
			return CAMPI[campo] || campo;
		},
		percorso(url) {
			try {
				const u = new URL(url);
				return decodeURIComponent(u.pathname + u.search);
			} catch (e) {
				return url;
			}
		},
		async esegui(action, urls) {
			this.occupato = true;
			const res = await this.$store.dispatch('brandimport/pagesAction', { brandId: this.brandId, action, urls });
			this.occupato = false;
			if (res.error) {
				this.$emit('message', testoErrore(res.error), 'error');
				return;
			}
			this.$emit('message', MESSAGGI[action]);
			this.$emit('changed', action === 'retry' ? res.data : null);
		},
	},
};
</script>

<style scoped>
.tabella ::v-deep td {
	font-size: 12px !important;
}
.indirizzo {
	word-break: break-all;
	font-size: 12px;
}
</style>
